import { createRouter, createWebHistory } from "vue-router";
import CustomerHub from "@/components/CustomerHub.vue";
import SignupForm from "@/components/SignupForm.vue";
import DownloadPage from "@/components/DownloadPage.vue";
import PolicyPage from "@/components/PolicyPage.vue";
import PageShell from "@/components/PageShell.vue";
import BrandingShell from "@/components/BrandingShell.vue";
import RatingPage from "@/components/RatingPage.vue";
import GamePage from "@/components/GamePage.vue";
import RatingRedirect from "@/components/RatingRedirect.vue";
import AddPointsPage from "@/components/AddPointsPage.vue";
import RecoveryPage from "@/components/RecoveryPage.vue";
import NotFoundPage from "@/components/NotFoundPage.vue";
import AppointmentPage from "@/components/AppointmentPage.vue";
import ReservationPage from "@/components/ReservationPage.vue";
import CustomerProfilePage from "@/components/CustomerProfilePage.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/:shortenedSignupPageId/ratingRedirect",
      name: "ratingRedirect",
      component: RatingRedirect,
    },
    {
      path: "/:shortenedSignupPageId/notFound",
      name: "notFound",
      component: NotFoundPage,
    },
    {
      path: "/",
      name: "pageShell",
      component: PageShell,
      children: [
        {
          path: "/:shortenedSignupPageId/:slugNameOrLocationId?/shop",
          name: "shopPage",
          component: () => import("@/components/shop/ShopPage.vue"),
          meta: { shop: true },
        },
        {
          path: "/:shortenedSignupPageId/profile",
          name: "customerProfilePage",
          component: CustomerProfilePage,
        },
        {
          path: "/:shortenedSignupPageId/:slugNameOrLocationId?/appointment",
          name: "appointmentPage",
          component: AppointmentPage,
        },
        {
          path: "/:shortenedSignupPageId/:slugNameOrLocationId?/reservation",
          name: "reservationPage",
          component: ReservationPage,
        },
        {
          path: "/",
          name: "brandingShell",
          component: BrandingShell,
          children: [
            {
              path: "/:shortenedSignupPageId/rating",
              name: "ratingPage",
              component: RatingPage,
            },
            {
              path: "/:shortenedSignupPageId/game/:gameParticipationId",
              name: "gamePage",
              component: GamePage,
            },
            {
              path: "/:shortenedSignupPageId/:slugNameOrLocationId?/download",
              name: "downloadPage",
              component: DownloadPage,
            },
            {
              path: "/:shortenedSignupPageId/:slugNameOrLocationId?/addPoints",
              name: "addPointsPage",
              component: AddPointsPage,
            },
            {
              path: "/:shortenedSignupPageId/policy",
              name: "policy",
              component: PolicyPage,
            },
            {
              path: "/:shortenedSignupPageId/recovery",
              name: "recoveryPage",
              component: RecoveryPage,
            },
            {
              path: "/:shortenedSignupPageId/:slugNameOrLocationId?",
              name: "customerHub",
              component: CustomerHub,
            },
            {
              path: "/:shortenedSignupPageId/:slugNameOrLocationId?/createCustomer",
              name: "createCustomerPage",
              component: SignupForm,
              meta: { card: true },
            },
          ],
        },
      ],
    },
  ],
});

export default router;
